import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPONSE_SPACES_LIST_ROOM_OS_DEVICES,
    RESPONSE_SPACES_ROOM_OS_DEVICE_ADDED,
    RESPONSE_SPACES_ROOM_OS_DEVICE_UPDATED,
    RESPONSE_SPACES_ROOM_OS_DEVICE_REMOVED,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/spaces/roomosMsgDefinitions";
import { RoomosHeader } from "userful-chronos-app-common-js/dist/models/spaces/roomos";
import spacesStore from "../../spacesStore";
import { roomosActions } from "../../roomosSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPONSE_SPACES_LIST_ROOM_OS_DEVICES, (payload) => {
    console.debug("receive RESPOND_LIST_SERVERS");
    const data = JSON.parse(payload) as RoomosHeader[];
    spacesStore.dispatch(roomosActions.setSpacesServersConfig(data));
});

registerMsgHandler(RESPONSE_SPACES_ROOM_OS_DEVICE_ADDED, (payload) => {
    console.debug("receive RESPOND_ADD_SERVER");
    const data = JSON.parse(payload) as RoomosHeader;
    spacesStore.dispatch(roomosActions.setSpacesConfig(data));
    spacesStore.dispatch(roomosActions.changeLoadState("RENDER"));
    spacesStore.dispatch(roomosActions.setOpenForm(false));
    spacesStore.dispatch(roomosActions.getRoomosDevicesFromServer({}));
});

registerErrorMsgHandlerByMsgDefinition(RESPONSE_SPACES_ROOM_OS_DEVICE_ADDED, (data) => {
    spacesStore.dispatch(roomosActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPONSE_SPACES_ROOM_OS_DEVICE_UPDATED, (payload) => {
    console.debug("receive RESPOND_ADD_SERVER");
    const data = JSON.parse(payload) as RoomosHeader;
    spacesStore.dispatch(roomosActions.setSpacesConfig(data));
    spacesStore.dispatch(roomosActions.changeLoadState("RENDER"));
    spacesStore.dispatch(roomosActions.setOpenForm(false));
    spacesStore.dispatch(roomosActions.getRoomosDevicesFromServer({}));
});

registerErrorMsgHandlerByMsgDefinition(RESPONSE_SPACES_ROOM_OS_DEVICE_UPDATED, (data) => {
    spacesStore.dispatch(roomosActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPONSE_SPACES_ROOM_OS_DEVICE_REMOVED, () => {
    console.debug("receive RESPOND_ADD_SERVER");
    spacesStore.dispatch(roomosActions.changeLoadState("RENDER"));
    spacesStore.dispatch(roomosActions.setOpenForm(false));
    spacesStore.dispatch(roomosActions.getRoomosDevicesFromServer({}));
});

registerErrorMsgHandlerByMsgDefinition(RESPONSE_SPACES_ROOM_OS_DEVICE_REMOVED, (data) => {
    spacesStore.dispatch(roomosActions.changeLoadState("RENDER"));
});
